import { CommonService, MotRequestSource } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const MotHistoryLookupQueryKey = 'MotHistoryLookupQueryKey';

export type MotHistoryLookupFilter = {
  regNo?: string;
  source?: MotRequestSource;
  sourceId?: number;
  userId?: number;
};

export const useMotHistoryLookupQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  filter: MotHistoryLookupFilter,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getLookUpMotHistoryWithRegNo>>,
      QueryError,
      Awaited<ReturnType<typeof CommonService.getLookUpMotHistoryWithRegNo>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [MotHistoryLookupQueryKey, ...(queryKey ?? [{ ...filter }])],
    () => CommonService.getLookUpMotHistoryWithRegNo(filter.regNo!, filter.source, filter.sourceId, filter.userId),
    options
  );
